export default class ImageLoader {
    public static loadImage(
        imgSrc: string,
        onLoad: (image: ImageBitmap) => void,
    ) {
        const img = new Image();
        img.onload = () => {
            createImageBitmap(img).then((result) => {
                console.log(`Loaded ${imgSrc}`);
                onLoad(result);
            });
        };
        img.src = imgSrc;
    }
}
